// extracted by mini-css-extract-plugin
module.exports = {"cover":"extension_cover__9t8YP","box":"extension_box__hkjgf","content":"extension_content__2ySx_","footer":"extension_footer__3GnJj"};